export const answer = [
    {
        "name": "测试",
        "idNumber": "123456789524568",
        "CumulativeChildEducation": 100,
        "CumulativeContinuingEducation": 100,
        "AccumulatedHousingLoanInterest": 100,
        "AccumulatedHousingRent": 300,
        "SupportTheElderlyCumulatively": 100,
        "AccumulatedInfantChild": 100,
        "CumulativeInfantCare": 100,
        "Answer_CurrentIncome": 1000,
        "Answer_CurrentExemptIncome": 100,
        "Answer_BasicEndowmentInsurance": 200,
        "Answer_BasicMedicalInsurance": 300,
        "Answer_UnemploymentInsurancePremium": 0,
        "Answer_HousingAccumulationFund": 0,
        "Answer_CumulativeChildEducation": 0,
        "Answer_CumulativeContinuingEducation": 0,
        "Answer_AccumulatedHousingLoanInterest": 0,
        "Answer_AccumulatedHousingRent": 0,
        "Answer_SupportTheElderlyCumulatively": 0,
        "Answer_AccumulatedInfantChild": 0,
        "Answer_EnterpriseAnnuity": 0,
        "Answer_CommercialHealthInsurance": 0,
        "Answer_TaxdeferredPensionInsurance": 0,
        "Answer_PreDeductibleContributions": 0,
        "Answer_TaxRelief": 0,
        "Answer_MinusCostTag": 0,
        "Answer_TheAmountTaxWithheld": 0,
        "Answer_TaxCreditPayable": 0,
        "_X_ROW_KEY": "row_130"
    },
    {
        "name": "测试1",
        "idNumber": "5463868628685",
        "CumulativeChildEducation": 100,
        "CumulativeContinuingEducation": 124,
        "AccumulatedHousingLoanInterest": 145,
        "AccumulatedHousingRent": 452,
        "SupportTheElderlyCumulatively": 200,
        "AccumulatedInfantChild": 100,
        "CumulativeInfantCare": 100,
        "Answer_CurrentIncome": 200,
        "Answer_CurrentExemptIncome": 0,
        "Answer_BasicEndowmentInsurance": 0,
        "Answer_BasicMedicalInsurance": 0,
        "Answer_UnemploymentInsurancePremium": 0,
        "Answer_HousingAccumulationFund": 0,
        "Answer_CumulativeChildEducation": 0,
        "Answer_CumulativeContinuingEducation": 0,
        "Answer_AccumulatedHousingLoanInterest": 0,
        "Answer_AccumulatedHousingRent": 0,
        "Answer_SupportTheElderlyCumulatively": 0,
        "Answer_AccumulatedInfantChild": 0,
        "Answer_EnterpriseAnnuity": 0,
        "Answer_CommercialHealthInsurance": 0,
        "Answer_TaxdeferredPensionInsurance": 0,
        "Answer_PreDeductibleContributions": 0,
        "Answer_TaxRelief": 0,
        "Answer_MinusCostTag": 0,
        "Answer_TheAmountTaxWithheld": 0,
        "Answer_TaxCreditPayable": 0,
        "_X_ROW_KEY": "row_131"
    },
    {
        "name": "测试3",
        "idNumber": "154682485264896",
        "CumulativeChildEducation": 0,
        "CumulativeContinuingEducation": 0,
        "AccumulatedHousingLoanInterest": 0,
        "AccumulatedHousingRent": 0,
        "SupportTheElderlyCumulatively": 0,
        "AccumulatedInfantChild": 0,
        "CumulativeInfantCare": 0,
        "Answer_CurrentIncome": 0,
        "Answer_CurrentExemptIncome": 0,
        "Answer_BasicEndowmentInsurance": 0,
        "Answer_BasicMedicalInsurance": 0,
        "Answer_UnemploymentInsurancePremium": 0,
        "Answer_HousingAccumulationFund": 0,
        "Answer_CumulativeChildEducation": 0,
        "Answer_CumulativeContinuingEducation": 0,
        "Answer_AccumulatedHousingLoanInterest": 0,
        "Answer_AccumulatedHousingRent": 0,
        "Answer_SupportTheElderlyCumulatively": 0,
        "Answer_AccumulatedInfantChild": 0,
        "Answer_EnterpriseAnnuity": 0,
        "Answer_CommercialHealthInsurance": 0,
        "Answer_TaxdeferredPensionInsurance": 0,
        "Answer_PreDeductibleContributions": 0,
        "Answer_TaxRelief": 0,
        "Answer_MinusCostTag": 0,
        "Answer_TheAmountTaxWithheld": 0,
        "Answer_TaxCreditPayable": 0,
        "_X_ROW_KEY": "row_48"
    }
]

export  const baseColumn = [
    {
        title:'姓名',
        key:'name'
    },
    {
        title:'身份证号码',
        key:'idNumber'
    },
]

export  const initialAnswerColumn = [
    {
        title:'累计子女教育',
        key:'CumulativeChildEducation'
    },
    {
        title:'累计继续教育',
        key:'CumulativeContinuingEducation'
    },
    {
        title:'累计住房贷款利息',
        key:'AccumulatedHousingLoanInterest'
    },
    {
        title:'累计住房租金',
        key:'AccumulatedHousingRent'
    },
    {
        title:'累计赡养老人',
        key:'SupportTheElderlyCumulatively'
    },
    {
        title:'累计婴幼儿照顾费',
        key:'AccumulatedInfantChild'
    },
    {
        title:'大病医疗',
        key:'CumulativeInfantCare'
    }
]

export const answerColumn = [
    {
        title:'本期收入',
        key:'Answer_CurrentIncome'
    },
    {
        title:'本期免税收入',
        key:'Answer_CurrentExemptIncome'
    },
    {
        title:'基本养老保险',
        key:'Answer_BasicEndowmentInsurance'
    },
    {
        title:'基本医疗保险',
        key:'Answer_BasicMedicalInsurance'
    },
    {
        title:'失业保险费',
        key:'Answer_UnemploymentInsurancePremium'
    },
    {
        title:'住房公积金',
        key:'Answer_HousingAccumulationFund'
    },
    {
        title:'累计子女教育',
        key:'Answer_CumulativeChildEducation'
    },
    {
        title:'累计继续教育',
        key:'Answer_CumulativeContinuingEducation'
    },
    {
        title:'累计住房贷款利息',
        key:'Answer_AccumulatedHousingLoanInterest'
    },
    {
        title:'累计住房租金',
        key:'Answer_AccumulatedHousingRent'
    },
    {
        title:'累计赡养老人',
        key:'Answer_SupportTheElderlyCumulatively'
    },
    {
        title:'累计婴幼儿照顾费',
        key:'Answer_AccumulatedInfantChild'
    },
    {
        title:'大病医疗',
        key:'Answer_CumulativeInfantCare'
    },
    {
        title:'企业(职业)年金',
        key:'Answer_EnterpriseAnnuity'
    },
    {
        title:'商业健康保险',
        key:'Answer_CommercialHealthInsurance'
    },
    {
        title:'税延养老保险',
        key:'Answer_TaxdeferredPensionInsurance'
    },
    {
        title:'准预扣除的捐款额',
        key:'Answer_PreDeductibleContributions'
    },
    {
        title:'减免税额',
        key:'Answer_TaxRelief'
    },
    {
        title:'减除费用',
        key:'Answer_MinusCostTag'
    },
    {
        title:'已扣缴税额',
        key:'Answer_TheAmountTaxWithheld'
    },
    {
        title:'应补退税额',
        key:'Answer_TaxCreditPayable'
    },
]